/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * Trims the value of a form control on blur.
 * Apply to any input/textarea bound via formControlName or ngModel.
 *
 * Usage: <sd-input formControlName="name" squadboxTrimOnBlur />
 */
@Directive({
  selector: '[squadboxTrimOnBlur]',
  standalone: true,
})
export class TrimOnBlurDirective {
  private readonly ngControl = inject(NgControl, { optional: true });

  @HostListener('focusout')
  onBlur(): void {
    const control = this.ngControl?.control;
    if (!control) return;

    const value = control.value;
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed !== value) {
        control.setValue(trimmed);
      }
    }
  }
}
